module.exports = __webpack_public_path__ + "static/media/intktober1closeup.2dc1c028.jpg";